<template>
    <div class="CartButton">

        <div class="button" @click="Check()">
            <div class="number" v-if="!closeBtn">
                {{totalAmount}}
            </div>
            <div class="text">
                {{message}}
            </div>
            <div class="fee" v-if="!closeBtn">
                ${{totalPrice}}
            </div>
        </div>

        <el-button type="warning" class="share-btn" @click="showModel = true" v-if="isShare">+</el-button>

        <!--todo 分享彈框-->
        <el-dialog
                :visible.sync="showModel"
                :modal="false"
                top="20%"
                width="80%"
                custom-class="commDialog">
            <div class="container">
                <img src="@/assets/images/dialog-order.svg" class="icon">
                <div slot="footer" class="dialog-footer">
                    <el-button @click="continueOrder" type="info" v-if="isOrder">繼續加點</el-button>
                    <el-button @click="share" type="info" v-if="isInvite">分享訂餐</el-button>
                    <el-button type="danger" plain v-if="isQuit">退出揪團</el-button>
                    <el-button type="danger" plain v-if="isCancel">取消揪團</el-button>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    export default {
        name: "CartButton",
        props: {
            message:{default: "查看購物車"},
            toRecord:Boolean,//前往訂單記錄
            toCart:Boolean,//前往購物車
            toComplete:Boolean,//揪團前往完成訂單
            isShare:Boolean,//揪團出現的更多
            isOrder:Boolean,//繼續加點
            isInvite:Boolean,//分享訂餐
            isQuit:Boolean,//退出揪團
            isCancel:Boolean,//取消揪團
            totalPrice:{ type:Number, default: 0 },
            totalAmount:{ type:Number, default: 0 },
            takeoutId:{ type:Number, default: 0 },
            submitToDo:null,

            storeId:{type:Number,default:0},
            brandName:{type:String,default:''},
            storeName:{type:String,default:''},
            closeBtn:Boolean, //預設flase
        },
        data() {
            return {
                showModel:false,
            }
        },
        methods: {
            //繼續加點用
            continueOrder(){
                this.showModel = false;
                this.$router.push({name:'OrderList'});
            },
            //分享訂餐用
            share(){
                this.showModel = false;
                this.$router.push({name:'OrderQrCodeTeamBuying'});
            },

            Check(){
                //前往訂單
                if(this.toRecord){
                    this.$router.push({name:'OrderRecordList'});
                }
                //前往購物車
                if(this.toCart){
                    if (this.takeoutId!==0) {
                        this.$router.go(-1);
                    }else{
                        this.$store.commit("clearCartPageSnapshot", {isKeepValue: true});
                        this.$router.push({name:'OrderCart'});
                    }
                }
                //前往揪團點餐完成
                if(this.toComplete){
                    this.$router.push({name:'OrderTeamBuyingComplete'});
                }
                if (this.submitToDo) {
                    this.submitToDo();
                }
                if(this.closeBtn){
                    console.log("-----closeBtn:",this.closeBtn);
                    this.$router.replace({name:'OrderList'});
                    return;
                }
            },

        }

    }
</script>
<style scoped lang="less">
    .el-dialog__wrapper{//因為用轉場z-index會受影響，所以要加上這個背景，套件部分遮罩modal要設為false
        background: rgba(0,0,0,.5);
    }
</style>

